import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/proposals/$proposalId_/edit')({});
